/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GenderEnum } from './GenderEnum';
import {
    GenderEnumFromJSON,
    GenderEnumFromJSONTyped,
    GenderEnumToJSON,
    GenderEnumToJSONTyped,
} from './GenderEnum';

/**
 * Response light for a patient
 * @export
 * @interface PatientLightResponse
 */
export interface PatientLightResponse {
    /**
     * Unique identifier of the patient
     * @type {string}
     * @memberof PatientLightResponse
     */
    patientId?: string;
    /**
     * Firstname of patient
     * @type {string}
     * @memberof PatientLightResponse
     */
    firstname?: string;
    /**
     * Lastname of patient
     * @type {string}
     * @memberof PatientLightResponse
     */
    lastname?: string;
    /**
     * Birthdate of patient
     * @type {string}
     * @memberof PatientLightResponse
     */
    birthdate?: string;
    /**
     * 
     * @type {GenderEnum}
     * @memberof PatientLightResponse
     */
    gender?: GenderEnum;
    /**
     * Serial number of patient
     * @type {string}
     * @memberof PatientLightResponse
     */
    serialNumber?: string;
}



/**
 * Check if a given object implements the PatientLightResponse interface.
 */
export function instanceOfPatientLightResponse(value: object): value is PatientLightResponse {
    return true;
}

export function PatientLightResponseFromJSON(json: any): PatientLightResponse {
    return PatientLightResponseFromJSONTyped(json, false);
}

export function PatientLightResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatientLightResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'patientId': json['patientId'] == null ? undefined : json['patientId'],
        'firstname': json['firstname'] == null ? undefined : json['firstname'],
        'lastname': json['lastname'] == null ? undefined : json['lastname'],
        'birthdate': json['birthdate'] == null ? undefined : json['birthdate'],
        'gender': json['gender'] == null ? undefined : GenderEnumFromJSON(json['gender']),
        'serialNumber': json['serialNumber'] == null ? undefined : json['serialNumber'],
    };
}

export function PatientLightResponseToJSON(json: any): PatientLightResponse {
    return PatientLightResponseToJSONTyped(json, false);
}

export function PatientLightResponseToJSONTyped(value?: PatientLightResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'patientId': value['patientId'],
        'firstname': value['firstname'],
        'lastname': value['lastname'],
        'birthdate': value['birthdate'],
        'gender': GenderEnumToJSON(value['gender']),
        'serialNumber': value['serialNumber'],
    };
}

